<template>
  <div :style="{ color: fontColor, background: backgrounds }" class="container">
    <img v-if="showIcon" :src="store.getters.logo" alt="ata" />
    <span @click="returnClick" v-else class="iconfont arrow-right"
      >&#xe603;</span
    >
    <div :style="{ marginRight: contentMarginR }" class="content">
      {{ content }}
    </div>
    <span @click="menuClick" class="iconfont menu">&#xe606;</span>
  </div>
  <teleport to="#side-popup">
    <Popup
      class="popup"
      v-model:show="show"
      position="right"
      :style="{ height: '100%', width: '40%' }"
    >
      <ul>
        <li @click="jumpHomeClick">
          <img :src="home" alt="首页" />
          <span>首页</span>
        </li>
        <li @click="logoutClick">
          <img :src="logout" alt="退出账号" />
          <span>退出账号</span>
        </li>
      </ul>
    </Popup>
  </teleport>
</template>

<script>
import home from "img/home.png";
import logout from "img/logout.png";
import { Popup } from "vant";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "CommonHeader",
  components: { Popup },
  props: {
    // 字体颜色
    fontColor: {
      type: String,
      default: "#fff",
    },
    // 当现实ata标志的时候为content加marginR
    contentMarginR: {
      type: String,
      default: "0px",
    },
    // content内容
    content: {
      type: String,
      required: true,
    },
    // 头部背景
    backgrounds: {
      type: String,
      default: "transparent",
    },
    // 是否展示ataicon
    showIcon: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    // 使用router
    const router = useRouter();
    // 使用store
    const store = useStore();
    // 菜单控制
    const show = ref(false);
    // 点击菜单
    const menuClick = () => {
      if (!show.value) {
        show.value = true;
      }
    };
    // 返回上一级
    const returnClick = () => {
      router.go(-1);
    };
    // 跳转首页
    const jumpHomeClick = () => {
      router.push(`/home/${store.state.testCode}`);
      show.value = false;
    };
    // 退出账号
    const logoutClick = () => {
      router.push(
        store.state.testCode && Number(store.state.authType) === 1
          ? `/login?type=${store.state.testCode}`
          : "/login"
      );
      show.value = false;
      localStorage.clear();
    };
    return {
      show,
      menuClick,
      home,
      logout,
      jumpHomeClick,
      returnClick,
      logoutClick,
      store,
    };
  },
};
</script>
<style scoped lang="scss">
.container {
  height: 100px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 10px;
  justify-content: space-between;
  box-sizing: border-box;
  img {
    // width: 185px;
    height: 40px;
  }
  .arrow-right {
    font-size: 55px;
  }
  .content {
    font-size: 35px;
    text-align: center;
  }
  .menu {
    font-size: 55px;
  }
}
.popup {
  ul {
    display: flex;
    flex-direction: column;
    li {
      display: flex;
      align-items: center;
      padding: 38px 40px;
      border-bottom: 1px solid #ddd;
      img {
        width: 36px;
        height: 36px;
      }
      span {
        font-size: 30px;
        color: #333;
        margin-left: 30px;
        margin-top: 3px;
      }
    }
  }
}
</style>
